import './App.css';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import Login from '../login/Login';
import Provider from '../provider/Provider';
import StaticLayout from '../static-layout/StaticLayout';
import ResetPassword from '../reset-password/ResetPassword';
import WebsiteSwitch from '../website-switch/WebsiteSwitch';
import NoWebsites from '../no-websites/NoWebsites';
import CreateClient from '../createClient/CreateClient';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
}));

function App() {
  const classes = useStyles();
  return (
    <Provider>
      <div className={classes.root} data-testid="app_test_id">
        <Router>
          <Switch>
            <Route path="/no-websites">
              <NoWebsites />
            </Route>
            <Route path="/create">
              <CreateClient />
            </Route>
            <Route path="/login">
              <Login /> {/* includes sidebar */}
            </Route>
            <Route
              path={[
                '/reset-password/:email/:code',
                '/reset-password',
                '/register/:email/:code',
                '/register',
              ]}
            >
              <ResetPassword /> {/* includes sidebar */}
            </Route>
            <Route path="/switch-website">
              <WebsiteSwitch /> {/* includes sidebar */}
            </Route>
            <Route
              path={[
                '',
                '/',
                '/dashboard',
                '/opportunities',
                '/opportunities/:call_id',
                '/leads',
                '/leads/full-view',
                '/backlinks',
                ...(process.env.REACT_APP_ENABLE_PREMIUM_BACKLINK === 'true' ? ['/premium-backlinks'] : []),
                ...(process.env.REACT_APP_ENABLE_YEXT === 'true' ? ['/yext'] : []),
                ...(process.env.REACT_APP_ENABLE_GEO_VISIBILITY === 'true' ? ['/geo-visibility', '/geo-visibility/queries'] : []),
                '/calls/full-view',
                '/content',
                '/content/full-view',
                '/content/full-view/:status',
                '/:domain/content/full-view/:status',
                '/analytics',
                '/analytics/gmb',
                '/analytics/gmb/locations',
                '/reputation',
                '/settings',
                '/paid-media',
                '/paid-media/full-view/campaigns',
                '/paid-media/full-view/locations',
                '/digital-pr',
                '/digital-pr/active-full-view',
                '/digital-pr/historic-full-view',
                '/support',
                '/keywords/full-view',
                '/content/assigned-pages',
                '/campaign-updates',
                '/campaign-updates/open/:message_id',
                '/campaign-updates/open/:domain/:message_id',
              ]}
              exact
            >
              {' '}
              {/* all static pages for logged in users */}
              <StaticLayout />
            </Route>
            <Route>
              <Redirect to="/" />
            </Route>
          </Switch>
        </Router>
      </div>
    </Provider>
  );
}

export default App;
